import { FC, ReactNode } from 'react'

interface Props {
  title?: string
  children: ReactNode
  className?: string
  onClose?: () => void
}

export const RetroWindow: FC<Props> = ({
  title,
  children,
  className = '',
  onClose,
}) => {
  return (
    <div className={`retro-window ${className}`}>
      {title && (
        <div className="retro-window-title flex items-center justify-between">
          <span>{title}</span>
          {onClose && (
            <button
              onClick={onClose}
              className="px-2 hover:bg-white/20 transition-colors"
              aria-label="Close"
            >
              X
            </button>
          )}
        </div>
      )}
      <div className="retro-window-content">{children}</div>
    </div>
  )
}
